var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.task
    ? _c("div", { staticClass: "card card-custom" }, [
        _c("div", { staticClass: "card-header d-flex" }, [
          _c(
            "h3",
            {
              staticClass: "card-title align-items-start flex-column",
              staticStyle: { width: "90%" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.task.name,
                    expression: "task.name"
                  }
                ],
                staticClass: "form-control-lg w-100",
                attrs: { type: "text" },
                domProps: { value: _vm.task.name },
                on: {
                  change: function($event) {
                    _vm.changed = true
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.task, "name", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-toolbar flex-column text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { "data-card-tool": "remove" },
                on: {
                  click: function($event) {
                    return _vm.deleteTask()
                  }
                }
              },
              [_vm._v("löschen")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "d-flex align-items-center mb-2" }, [
            _c(
              "div",
              { staticClass: "symbol symbol-40 symbol-light-primary mr-5" },
              [
                _vm.task.type == "image"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-success" }, [
                        _c("span", { staticClass: "symbol-label" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "svg-icon svg-icon-primary svg-icon-3x"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    width: "24px",
                                    height: "24px",
                                    viewBox: "0 0 24 24",
                                    version: "1.1"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        stroke: "none",
                                        "stroke-width": "1",
                                        fill: "none",
                                        "fill-rule": "evenodd"
                                      }
                                    },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          x: "0",
                                          y: "0",
                                          width: "24",
                                          height: "24"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M5,7 L19,7 C20.1045695,7 21,7.8954305 21,9 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,9 C3,7.8954305 3.8954305,7 5,7 Z M12,17 C14.209139,17 16,15.209139 16,13 C16,10.790861 14.209139,9 12,9 C9.790861,9 8,10.790861 8,13 C8,15.209139 9.790861,17 12,17 Z",
                                          fill: "#FFFFFF"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          fill: "#FFFFFF",
                                          opacity: "0.3",
                                          x: "9",
                                          y: "4",
                                          width: "6",
                                          height: "2",
                                          rx: "1"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("circle", {
                                        attrs: {
                                          fill: "#FFFFFF",
                                          opacity: "0.3",
                                          cx: "12",
                                          cy: "13",
                                          r: "2"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm.task.type == "service_price"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-danger mb-3" }, [
                        _c(
                          "span",
                          {
                            staticClass: "svg-icon svg-icon-primary svg-icon-2x"
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        fill: "#FFFFFF",
                                        x: "4",
                                        y: "11",
                                        width: "16",
                                        height: "2",
                                        rx: "1"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("button", { staticClass: "btn btn-secondary" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "svg-icon svg-icon-primary svg-icon-2x"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    width: "24px",
                                    height: "24px",
                                    viewBox: "0 0 24 24",
                                    version: "1.1"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        stroke: "none",
                                        "stroke-width": "1",
                                        fill: "none",
                                        "fill-rule": "evenodd"
                                      }
                                    },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          x: "0",
                                          y: "0",
                                          width: "24",
                                          height: "24"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M19.2078777,9.84836149 C20.3303823,11.0178941 21,12 21,12 C21,12 16.9090909,18 12,18 C11.6893441,18 11.3879033,17.9864845 11.0955026,17.9607365 L19.2078777,9.84836149 Z",
                                          fill: "#000000",
                                          "fill-rule": "nonzero"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M14.5051465,6.49485351 L12,9 C10.3431458,9 9,10.3431458 9,12 L5.52661464,15.4733854 C3.75006453,13.8334911 3,12 3,12 C3,12 5.45454545,6 12,6 C12.8665422,6 13.7075911,6.18695134 14.5051465,6.49485351 Z",
                                          fill: "#000000",
                                          "fill-rule": "nonzero"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          fill: "#000000",
                                          opacity: "0.3",
                                          transform:
                                            "translate(12.524621, 12.424621) rotate(-45.000000) translate(-12.524621, -12.424621) ",
                                          x: "3.02462111",
                                          y: "11.4246212",
                                          width: "19",
                                          height: "2"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm.task.type == "service"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-success" }, [
                        _c("span", { staticClass: "symbol-label" }, [
                          _c("span", { staticClass: "svg-icon svg-icon-2x" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z",
                                        fill: "#FFFFFF"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z",
                                        fill: "#000000"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("rect", {
                                      attrs: {
                                        fill: "#000000",
                                        x: "7",
                                        y: "10",
                                        width: "5",
                                        height: "2",
                                        rx: "1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("rect", {
                                      attrs: {
                                        fill: "#000000",
                                        x: "7",
                                        y: "14",
                                        width: "9",
                                        height: "2",
                                        rx: "1"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm.task.type == "package_return"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-warning" }, [
                        _c("span", { staticClass: "symbol-label" }, [
                          _c("span", { staticClass: "svg-icon svg-icon-2x" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z",
                                        fill: "#FFFFFF"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z",
                                        fill: "#000000"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm.task.type == "package"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-success" }, [
                        _c(
                          "span",
                          {
                            staticClass: "svg-icon svg-icon-primary svg-icon-2x"
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z",
                                        fill: "#FFFFFF"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z",
                                        fill: "#000000"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm.task.type == "package_return"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-success" }, [
                        _c("span", { staticClass: "symbol-label" }, [
                          _c("span", { staticClass: "svg-icon svg-icon-2x" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "0",
                                        y: "0",
                                        width: "24",
                                        height: "24"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z",
                                        fill: "#FFFFFF"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z",
                                        fill: "#FFFFFF",
                                        opacity: "0.3"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm.task.type == "other_costs"
                  ? _c("div", [
                      _c("button", { staticClass: "btn btn-danger mb-3" }, [
                        _c(
                          "span",
                          {
                            staticClass: "svg-icon svg-icon-primary svg-icon-2x"
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  width: "24px",
                                  height: "24px",
                                  viewBox: "0 0 24 24",
                                  version: "1.1"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        fill: "#FFFFFF",
                                        x: "4",
                                        y: "11",
                                        width: "16",
                                        height: "2",
                                        rx: "1"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("button", { staticClass: "btn btn-secondary" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "svg-icon svg-icon-primary svg-icon-2x"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    width: "24px",
                                    height: "24px",
                                    viewBox: "0 0 24 24",
                                    version: "1.1"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        stroke: "none",
                                        "stroke-width": "1",
                                        fill: "none",
                                        "fill-rule": "evenodd"
                                      }
                                    },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          x: "0",
                                          y: "0",
                                          width: "24",
                                          height: "24"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M19.2078777,9.84836149 C20.3303823,11.0178941 21,12 21,12 C21,12 16.9090909,18 12,18 C11.6893441,18 11.3879033,17.9864845 11.0955026,17.9607365 L19.2078777,9.84836149 Z",
                                          fill: "#000000",
                                          "fill-rule": "nonzero"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M14.5051465,6.49485351 L12,9 C10.3431458,9 9,10.3431458 9,12 L5.52661464,15.4733854 C3.75006453,13.8334911 3,12 3,12 C3,12 5.45454545,6 12,6 C12.8665422,6 13.7075911,6.18695134 14.5051465,6.49485351 Z",
                                          fill: "#000000",
                                          "fill-rule": "nonzero"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          fill: "#000000",
                                          opacity: "0.3",
                                          transform:
                                            "translate(12.524621, 12.424621) rotate(-45.000000) translate(-12.524621, -12.424621) ",
                                          x: "3.02462111",
                                          y: "11.4246212",
                                          width: "19",
                                          height: "2"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-3" }, [
                  _vm.task.type == "image"
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Bildanzahl")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.task.estimation_range,
                                expression: "task.estimation_range"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.task,
                                    "estimation_range",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  _vm.changed = true
                                }
                              ]
                            }
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _vm._l(_vm.estimationRange, function(item) {
                              return _c("option", [_vm._v(_vm._s(item))])
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-3" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm.task.type == "image"
                      ? _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Bildanzahl exakt")
                        ])
                      : _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Stück")
                        ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.task.quantity,
                          expression: "task.quantity"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number" },
                      domProps: { value: _vm.task.quantity },
                      on: {
                        change: function($event) {
                          _vm.changed = true
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.task, "quantity", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-3" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm.task.type == "image"
                      ? _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Bilder pro Stunde")
                        ])
                      : _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Stück pro Stunde")
                        ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.task.images_per_hour,
                          expression: "task.images_per_hour"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", step: "1" },
                      domProps: { value: _vm.task.images_per_hour },
                      on: {
                        change: function($event) {
                          _vm.changed = true
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.task,
                            "images_per_hour",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-3" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm.task.type == "image"
                      ? _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Preis pro Bild")
                        ])
                      : _c("label", { staticClass: "text-dark" }, [
                          _vm._v("Preis pro Stück")
                        ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.task.price,
                          expression: "task.price"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number" },
                      domProps: { value: _vm.task.price },
                      on: {
                        change: function($event) {
                          _vm.changed = true
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.task, "price", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "text-dark" }, [
                      _vm._v("Weitere Informationen")
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.task.description,
                          expression: "task.description"
                        }
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.task.description },
                      on: {
                        change: function($event) {
                          _vm.changed = true
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.task, "description", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                !_vm.hasProject
                  ? _c("div", { staticClass: "col-12 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          attrs: { disabled: !_vm.changed },
                          on: {
                            click: function($event) {
                              return _vm.updateTask()
                            }
                          }
                        },
                        [_vm._v("speichern")]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.offerTask.type == "image" && !_vm.hasProject
          ? _c("div", { staticClass: "card-footer" }, [
              _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "text-left flex-column" }, [
                  _c("button", {
                    staticClass: "btn btn-sm btn-dark mr-2",
                    domProps: { innerHTML: _vm._s("Kalkulation") }
                  }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn btn-sm btn-dark mr-2",
                    domProps: {
                      innerHTML: _vm._s("Bildpreis " + _vm.priceCalc(135))
                    },
                    on: {
                      click: function($event) {
                        _vm.setPrice(135)
                        _vm.changed = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn btn-sm btn-dark mr-2",
                    domProps: {
                      innerHTML: _vm._s("Bildpreis SLA " + _vm.priceCalc(120))
                    },
                    on: {
                      click: function($event) {
                        _vm.setPrice(120)
                        _vm.changed = true
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right flex-column" }, [
                  _c("button", {
                    staticClass: "btn btn-sm btn-dark",
                    domProps: {
                      innerHTML: _vm._s("Task Umsatz " + _vm.priceCalcTask())
                    }
                  })
                ])
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }